















































import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo() {
    return {
      title: `${this.$t('meta.informationsTitle')}`,
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: `${this.$t('meta.informationsDescription')}`
        },
        {
          name: 'og:title',
          content: `${this.$t('meta.informationsTitle')}`
        },
        {
          name: 'og:description',
          content: `${this.$t('meta.informationsDescription')}`
        },
        {
          name: 'twitter:title',
          content: `${this.$t('meta.informationsTitle')}`
        },
        {
          name: 'twitter:description',
          content: `${this.$t('meta.informationsDescription')}`
        }
      ]
    }
  }
})
export default class Informations extends Vue {

}
